import React from 'react'
import { connect } from 'react-redux'

import OptionList from '../option-list'
import { sortOptions } from '../../../utils/option-sort'

const mapStateToProps = (state) => {
    return {
        options: sortOptions(state.adminServiceStyles)
    }
}

const ServiceStyles = ({ options }) => {
    return (
        <OptionList
            endpoint="admin/service-styles"
            options={options}
            singular="Service Style" />
    )
}

export default connect(mapStateToProps)(ServiceStyles)
